import { createRoute } from '@tanstack/react-router';
import MessagesPage from '@/features/dashboard/messages/pages/MessagesPage.tsx';
import { appRoute } from '@/features/dashboard/_root/routes/appRoute.tsx';
import { listSearchSchema } from '@/components/table/routes/listSearchParams.ts';

export const messagesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/messages',
  component: MessagesPage,
  validateSearch: listSearchSchema,
});
